var _style;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 48,
      height: 48,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8B8B8B;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "327.41,157.358 256.009,228.759 184.608,157.358 157.366,184.591 228.776,256.009 157.366,327.409  184.608,354.651 256.009,283.233 327.41,354.651 354.651,327.409 283.242,256.009 354.651,184.591  ",
    style: {
      fill: "rgb(120,120,120)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.022,74.978C390.764,28.686,326.636-0.008,256.009,0C185.372-0.008,121.245,28.686,74.987,74.978 C28.686,121.236-0.008,185.372,0,256c-0.008,70.628,28.686,134.764,74.987,181.022c46.258,46.292,110.385,74.995,181.022,74.978 c70.628,0.016,134.755-28.686,181.013-74.978C483.322,390.764,512.018,326.628,512,256 C512.018,185.372,483.322,121.236,437.022,74.978z M408.344,408.335c-39.052,39.019-92.787,63.1-152.335,63.116 c-59.564-0.016-113.292-24.098-152.353-63.116C64.646,369.283,40.566,315.564,40.557,256c0.009-59.564,24.089-113.3,63.099-152.344 c39.061-39.027,92.788-63.091,152.353-63.099c59.548,0.008,113.283,24.072,152.335,63.099 c39.019,39.044,63.091,92.78,63.108,152.344C471.435,315.564,447.363,369.283,408.344,408.335z",
    style: {
      fill: "rgb(120, 120, 120)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.cf4dbaee.svg";
export { ForwardRef as ReactComponent };